<div class="page">
    <div class="page-content">

      <div class="page-content" *ngIf="articleData">
        <div class="single-post-date">{{articleData.date}}</div>
        <h1 class="single-post-title">{{articleData.title}}</h1>
    
        <div style="margin: 1rem auto; display: flex;justify-content: center;">
          <img [src]="articleData.imageUrl" alt="" class="single-cover-image" style="max-height: 500px;width: auto;">
        </div>
        <span class="card-category" *ngFor="let category of articleData.categories">{{category}}</span>
        <div class="single-post-content">
    
          <p class="justify">{{articleData.parag1}}</p>
          <h2>{{articleData.subtitle}}</h2>
          <p class="justify">{{articleData.parag2}}</p>
          <h2>{{articleData.subtitle2}}</h2>
    
          <p class="justify">{{articleData.parag3}}</p>
    
          <h2>{{articleData.listDataTitle}}</h2>
          <ul>
            <li *ngFor="let ele of articleData.listData">
              {{ele}}
            </li>
          </ul>
          <p class="justify" *ngIf="articleData.parag4">{{articleData.parag4}}</p>
          <p class="justify" *ngIf="articleData.parag5">{{articleData.parag5}}</p>
          <ul>
            <li *ngFor="let ele of articleData.listData2">
              {{ele}}
            </li>
          </ul>
    
        </div>
      </div>
  </div>
</div>

<div class="article-container">
  <mat-card *ngIf="false">
    <img mat-card-image [src]="article.imageUrl" alt="Article Image">
    <mat-card-header>
      <mat-card-title>{{ article.name }}</mat-card-title>
      <mat-card-subtitle>
        <div class="author-info">
          <img mat-card-avatar [src]="article.authorImageUrl" alt="Author Image">
          <div>
            <span>{{ article.author }}</span>
            <span>{{ article.authorCareer }}</span>
            <span>{{ article.date | date: 'longDate' }}</span>
          </div>
        </div>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <p class="description">{{ article.description }}</p>
      <blockquote class="quote">{{ article.quote }}</blockquote>
      <p>{{ article.paragraph1 }}</p>
      <p>{{ article.paragraph2 }}</p>
      <p>{{ article.paragraph3 }}</p>
      <!-- <div *ngIf="article.videoUrl" class="video-container">
        <iframe [src]="article.videoUrl" frameborder="0" allowfullscreen></iframe>
      </div> -->
    </mat-card-content>
    <mat-card-footer>
      <div class="tags">
        <mat-chip-list>
          <mat-chip color="primary" selected>{{ article.category }}</mat-chip>
          <mat-chip color="primary" selected>{{ article.country }}</mat-chip>
        </mat-chip-list>
      </div>
      <div class="social-links">
        <a *ngIf="article.youtubeLink" [href]="article.youtubeLink" target="_blank"><mat-icon>youtube</mat-icon></a>
        <a *ngIf="article.websiteLink" [href]="article.websiteLink" target="_blank"><mat-icon>language</mat-icon></a>
        <a *ngIf="article.facebookLink" [href]="article.facebookLink" target="_blank"><mat-icon>facebook</mat-icon></a>
        <a *ngIf="article.instagramLink" [href]="article.instagramLink" target="_blank"><mat-icon>instagram</mat-icon></a>
        <!-- <a *ngIf="article.tiktokLink" [href]="article.tiktokLink" target="_blank"><mat-icon>tiktok</mat-icon></a> -->
      </div>
    </mat-card-footer>
  </mat-card>
</div>